'use strict';

angular.module('shiftTraderPrintApp')
  .controller('SchedulePrintCtrl', function ($scope, $window, $interval, $rootScope, $location, $state, $uibModal, Session,
                                             TimeService, WorkPeriods, WorkPeriodStore, AvailabilityRules, Organizations,
                                             me, theDate, allPositions, allWorkPeriods, allUsers, UserPermissionsService) {

    $scope.me = me;
    $scope.allPositions = _.map(allPositions, function(pos) {
      if (_.isUndefined(pos.department_id)) {
        pos.department_id = null;
      }
      return pos;
    });
    $scope.allWorkPeriods = allWorkPeriods;

    $scope.allUsers = _.where(allUsers, function(u) {
      return u.memberships[0].active;
    });

    $scope.nowTime = TimeService.getNowInStoreTime();

    $scope.printScreen = function() {
      $window.print();
    };

    $scope.miniOrg = Organizations.initWithData($scope.me.memberships[0].organization);
    $scope.orgPictureUrl = $scope.miniOrg.$hasCustomLogo() ? $scope.miniOrg.logo_urls.medium :
        "https://d327l0dy67qzb.cloudfront.net/landing/images/Shift-Agent-ICON-300px.png";

    $scope.showNoDepartmentArea = _.any($scope.allPositions, {department_id: null});

    Organizations.getById($scope.me.memberships[0].organization.id)
        .then(function(data) {
          $scope.org = data;
          $scope.orgPictureUrl = $scope.org.$hasCustomLogo() ? $scope.org.logo_urls.medium :
              "https://d327l0dy67qzb.cloudfront.net/landing/images/Shift-Agent-ICON-300px.png";
          $scope.departments = $scope.org.departments;
          if (_.any($scope.allPositions, {department_id: null}) && !_.any($scope.departments, {id: null})) {
            $scope.departments.push({
              id: null,
              name: 'Uncategorized'
            });
          }

          _.forEach($scope.allPositions, function(pos) {
            var match = _.find($scope.departments, {id: pos.department_id});
            if (!_.isUndefined(match)) {
              if (!_.has(match, '_position_ids')) {
                match._position_ids = [];
              }

              match._position_ids.push(pos.id);
            }
          });

          updateHasUnassignedByDept();
          updateUserHasWorkPeriodsByDept();
          updateView();
        });


    $scope.settings = {
      showUnpublished: _.isUndefined(($location.search()).showUnpublished) ? false : ($location.search()).showUnpublished === 'true',
      autoRefresh: true,
      autoRefreshFaster: false,
      selectedDepartment: -1,
      autoRefreshFasterTimer: 0,
      onlyShowUsersWithWorkPeriods: false,
      groupByDepartment: true
    };

    if (Session.getPrintSettings() && Session.getPrintSettings()['weekView'] && !_.isEmpty(Session.getPrintSettings()['weekView'])) {
      $scope.settings = _.extend($scope.settings, Session.getPrintSettings()['weekView']);

    }

    if (!$scope.me.$isAdmin() && !$scope.me.$isManager()) {
      $scope.settings.autoRefresh = false;
      $scope.settings.autoRefreshFaster = false;
    }

    $scope.beginningOfWeek = TimeService.getWeekTwixFromMoment(theDate, 0, 0).start;
    $scope.dateRangesInWeek = _.map(_.range(0,7), function(num) {
      return moment($scope.beginningOfWeek).add(num, 'days')
        .twix(moment($scope.beginningOfWeek).add(num + 1, 'days'));
    });

    $scope.state = {
      rawPermissions: null,
      derivedPermissions: null
    };

    function processRawPermissions() {
      var rawPerm = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        canShowUnpublished: rawPerm['work_periods.view_unpublished'],
        canShowDaysOff: rawPerm['availability_rules.view_in_org'],
        canAutoReloadPage: rawPerm['ui.scheduling.view_timeline']
      };

      $scope.settings.showApprovedDaysOff = $scope.state.derivedPermissions.canShowDaysOff;

      if ($scope.state.derivedPermissions.canShowDaysOff) {
        getDaysOff();
      }

      updateView();
    }

    var permissionsToLookUp = [
      'work_periods.view_unpublished',
      'availability_rules.view_in_org',
      'ui.scheduling.view_timeline' // if you can view the timeline, then we'll let you refresh the page automatically
    ];

    UserPermissionsService.getCanDict(permissionsToLookUp, $scope.miniOrg.id)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();
      });

    function getDaysOff() {
      AvailabilityRules.getAllApprovedDaysOff({
        start_date: $scope.beginningOfWeek.format('YYYY-MM-DD')
      })
          .then(function(rules) {
            if (!_.isUndefined(rules)) {
              $scope.approvedDaysOff = rules;
              calculateDaysOffStructure();
            }
          });
    }

    $scope.nextWeekDate = {date: moment($scope.dateRangesInWeek[6].start).add(1,'days').format('YYYY-MM-DD')};
    $scope.lastWeekDate = {date: moment($scope.dateRangesInWeek[0].start).subtract(7, 'days').format('YYYY-MM-DD')};

    $scope.goToNextWeek = function() {
      var path = '/schedulePrint/' + $scope.nextWeekDate.date;
      if ($scope.settings.showUnpublished) {
        path += '?showUnpublished=true';
      }
      $location.url(path);
    };

    $scope.goToLastWeek = function() {
      var path = '/schedulePrint/' + $scope.lastWeekDate.date;
      if ($scope.settings.showUnpublished) {
        path += '?showUnpublished=true';
      }
      $location.url(path);
    };

    var lastRefreshSettings;
    var workPeriodIntervalPromise, daysOffIntervalPromise;

    var updateView = function() {
      //console.log('updateView start');
      if ($scope.settings.selectedDepartment > -1) {
        $scope.filteredDepartments = [_.find($scope.departments, {id: $scope.settings.selectedDepartment})];
      } else {
        $scope.filteredDepartments = $scope.departments;
      }

      if (!_.isUndefined(workPeriodIntervalPromise)) {
        $interval.cancel(workPeriodIntervalPromise);
      }

      if (!_.isUndefined(daysOffIntervalPromise)) {
        $interval.cancel(daysOffIntervalPromise);
      }


      if ($scope.settings.autoRefresh) {
        if ($scope.state.derivedPermissions && $scope.state.derivedPermissions.canAutoReloadPage && $scope.state.derivedPermissions.canShowDaysOff) {
          daysOffIntervalPromise = $interval(function() {
            AvailabilityRules.getRecentlyUpdatedOrNewDaysOff({recent_since: moment($scope.nowTime).subtract(10, 'seconds').format()})
              .then(function(daysOff) {
                // console.log(daysOff);

                _.each(daysOff, function(dayOff) {
                  var idx = _.findIndex($scope.approvedDaysOff, {id: dayOff.id});

                  if (!dayOff.active) {
                    // remove matching dayOff from $scope.daysOff
                    if (idx > -1) {
                      $scope.approvedDaysOff.splice(idx, 1);
                    }
                  } else {
                    if (idx > -1) {
                      $scope.approvedDaysOff[idx] = dayOff;
                    } else {
                      $scope.approvedDaysOff.push(dayOff);
                    }
                  }
                });

                if (daysOff.length > 0) {
                  calculateDaysOffStructure();
                }
              });
          }, 5 * 60 * 1000);
        }

        workPeriodIntervalPromise = $interval(function() {
          // console.log('intervalExec');

          if ($scope.settings.autoRefreshFaster) {
            if ($scope.settings.autoRefreshFasterTimer >= 60 * 12) { // 60 minutes with 12 5s intervals. autoRefresh turns off after an hour
              $scope.settings.autoRefreshFasterTimer = 0;
              $scope.settings.autoRefreshFaster = false;
              updateView();
            } else {
              $scope.settings.autoRefreshFasterTimer += 1;
            }
          }

          //var twix = TimeService.getWeekTwixFromMoment(theDate, 1, 0);
          var data = {
            start_time: moment($scope.nowTime).format(),
            //end_time: twix.end.format(),
            recent_since: moment($scope.nowTime).subtract(10, 'seconds').format(),
            organization_id: $scope.me.memberships[0].organization.id,
            mode: 'recent_new_or_updated'
          };

          WorkPeriods.getAll(data, true)
              .then(function(results) {

                //returns an array of workPeriods that are new or that have been modified
                _.forEach(results, function(wp) {
                  var oldWpEntry = false; // used to denote if the user_id of a wp has changed;
                  var oldWpUserId = false;
                  var newWpUserId = false;
                  var oldWpDayIdx = -1;

                  var wpObj = WorkPeriods.initWithData(wp);

                  if (wpObj.$isAssigned()) {
                    newWpUserId = wpObj.user.id;
                  }

                  var matchingIndex = _.findIndex($scope.allWorkPeriods, {id: wp.id});
                  if (matchingIndex > -1) {
                    if ($scope.allWorkPeriods[matchingIndex].$isAssigned()) {
                      oldWpUserId = $scope.allWorkPeriods[matchingIndex].user.id;
                    }
                    oldWpEntry = _.cloneDeep($scope.allWorkPeriods[matchingIndex]);

                    oldWpDayIdx = _.findIndex($scope.dateRangesInWeek, function(dayTwix) {
                      return dayTwix.contains(oldWpEntry.start_time);
                    });

                    $scope.allWorkPeriods[matchingIndex] = wpObj;
                  } else {
                    $scope.allWorkPeriods.push(wpObj);
                  }
                  WorkPeriodStore.updateOrAdd(wpObj);

                  // Look through all of the workPeriod data structures and
                  // only make the updates absolutely necessary for the
                  // purpose of not redrawing the whole DOM whenever _.where's execute.

                  // First: search through all existing IDs and see if we have a hit
                  var assignedWpIdx;
                  var unassignedWpIdx;

                  _.forEach($scope.allUsers, function(u) {
                    _.forEach(u._workPeriodsByDay, function(wps) {
                      assignedWpIdx = _.findIndex(wps, {id: wp.id, active: true});
                      if (assignedWpIdx > -1) {
                        return false;
                      }
                    });
                    if (assignedWpIdx > -1) {
                      return false;
                    }
                  });

                  _.forEach($scope.unassignedWorkPeriodsByDay, function(wps) {
                    unassignedWpIdx = _.findIndex(wps, {id: wp.id});
                    if (unassignedWpIdx > -1) {
                      return false;
                    }
                  });

                  var allUsersIdx;
                  // make sure that the newest workPeriod coming in has a user (is actually assigned)
                  if (newWpUserId) {
                    allUsersIdx = _.findIndex($scope.allUsers, {id: wp.user.id});
                  }

                  var newWpDayIdx = _.findIndex($scope.dateRangesInWeek, function(dayTwix) {
                    return dayTwix.contains(wpObj.start_time);
                  });

                  console.log('assignedWpIdx: ' + assignedWpIdx);
                  console.log('unassignedWpIdx: ' + unassignedWpIdx);
                  console.log('oldWpUserId: ' + oldWpUserId);
                  console.log('newWpUserId: ' + newWpUserId);
                  console.log('newWpDayIdx: ' + newWpDayIdx);
                  console.log('oldWpDayIdx: ' + oldWpDayIdx);

                  if (newWpDayIdx > -1 && oldWpDayIdx > -1) {
                    if (wpObj.active) {

                      // if an entry exists in the assigned list
                      if (assignedWpIdx > -1) {
                        if (oldWpUserId && !newWpUserId) {
                          // case where previous wp had a user and new one is unassigned

                          //remove work period from previous user
                          removeAssignedWp(oldWpUserId, oldWpEntry);

                          //add work period to unassigned day if its in the same week
                          if (newWpDayIdx > -1) {
                            $scope.unassignedWorkPeriodsByDay[newWpDayIdx].push(wpObj);
                          }

                        } else if (oldWpUserId === newWpUserId && oldWpUserId) {
                          // case where workPeriod.user did not change in edit

                          if (newWpDayIdx === oldWpDayIdx) {
                            // same day as last wp record
                            $scope.allUsers[allUsersIdx]._workPeriodsByDay[newWpDayIdx][assignedWpIdx].$reinitialize(wp);
                          } else {
                            removeAssignedWp(oldWpUserId, oldWpEntry);

                            // only if we have a matching day index do we add the shift (could be a different week now!)
                            if (newWpDayIdx > -1) {
                              $scope.allUsers[allUsersIdx]._workPeriodsByDay[newWpDayIdx].push(wpObj);
                            }
                          }

                        } else if (oldWpUserId !== newWpUserId && oldWpUserId && newWpUserId) {
                          // oldWpUserId !== newWpUserId
                          // case where workPeriod.user was changed on workPeriod

                          //remove work period from previous user
                          removeAssignedWp(oldWpUserId, oldWpEntry);

                          // add work period to new user
                          // only if we have a matching day index do we add the shift (could be a different week now!)
                          if (newWpDayIdx > -1) {
                            $scope.allUsers[allUsersIdx]._workPeriodsByDay[newWpDayIdx].push(wpObj);
                          }

                        } else {
                          console.log('this state should never exist');
                        }
                      } else if (unassignedWpIdx > -1) {
                        if (oldWpUserId && newWpUserId) {
                          // case where wp was modified and user is still unassigned

                          if (newWpDayIdx === oldWpDayIdx) {
                            // same day as last wp record
                            $scope.unassignedWorkPeriodsByDay[newWpDayIdx][unassignedWpIdx].$reinitialize(wp);
                          } else {
                            $scope.unassignedWorkPeriodsByDay[newWpDayIdx].splice(unassignedWpIdx, 1);

                            // only if we have a matching day index do we add the shift (could be a different week now!)
                            if (newWpDayIdx > -1) {
                              $scope.unassignedWorkPeriodsByDay[newWpDayIdx].push(wpObj);
                            }
                          }

                        } else if (!oldWpUserId && newWpUserId) {
                          // case where previous wp was unassigned and new one is assigned
                          $scope.unassignedWorkPeriodsByDay[oldWpDayIdx].splice(unassignedWpIdx, 1);

                          if (newWpDayIdx > -1) {
                            $scope.allUsers[allUsersIdx]._workPeriodsByDay[newWpDayIdx].push(wpObj);
                          }

                        } else {
                          console.log('this state should also never exist');
                        }
                      } else {
                        //the new wp doesn't exist anywhere
                        if (wpObj.$isAssigned()) {
                          if (wpObj.active) {
                            $scope.allUsers[allUsersIdx]._workPeriodsByDay[newWpDayIdx].push(wpObj);
                          }
                        } else {
                          if (wpObj.active) {
                            $scope.unassignedWorkPeriodsByDay[newWpDayIdx].push(wpObj);
                          }
                        }
                      }
                    } else {
                      // wpObj is NOT active, so remove it
                      if (wpObj.$isAssigned()) {
                        if (assignedWpIdx > -1) {
                          $scope.allUsers[allUsersIdx]._workPeriodsByDay[newWpDayIdx].splice(assignedWpIdx, 1);
                        }
                      } else {
                        if (unassignedWpIdx > -1) {
                          $scope.unassignedWorkPeriodsByDay[newWpDayIdx].splice(unassignedWpIdx, 1);
                        }
                      }
                    }

                  }
                });


                updateWorkPeriodObjects();
                updateHasUnassignedByDept();
                updateUserHasWorkPeriodsByDept();

                $scope.nowTime = TimeService.getNowInStoreTime();

                calculateDaysOffStructure();
              }, function() {
                console.log('load failed');
              });
        }, $scope.settings.autoRefreshFaster ? 5000 : 60 * 1000);
      } else {
        console.log('break that promise');
        if (!_.isUndefined(workPeriodIntervalPromise)) {
          $interval.cancel(workPeriodIntervalPromise);
        }
      }

      $rootScope.printControllerLoaded = true;
      console.log('updateView end');
    };

    var removeAssignedWp = function(user_id, wp) {
      var userMatchIdx = _.findIndex($scope.allUsers, {id: user_id});
      var oldDayIdx = _.findIndex($scope.allUsers[userMatchIdx]._workPeriodsByDay, function(d) {
        return _.any(d, function(w) {
          return w.id === wp.id;
        });
      });
      var oldWpIdx = _.findIndex($scope.allUsers[userMatchIdx]._workPeriodsByDay[oldDayIdx], {id: wp.id});
      $scope.allUsers[userMatchIdx]._workPeriodsByDay[oldDayIdx].splice(oldWpIdx, 1);
    };

    var updateWorkPeriodObjects = function() {
      console.log('updateWorkPeriodObjects start');
      $scope.filteredWorkPeriods = _.where($scope.allWorkPeriods, function(wp) {
        return wp.active &&
            ($scope.settings.showUnpublished || wp.$isPublished());
      });

      //console.log(_.cloneDeep($scope.dateRangesInWeek));
      //console.log(_.cloneDeep($scope.workPeriodsByDay));
      $scope.workPeriodsByDay = _.map($scope.dateRangesInWeek, function(dayTwix) {
        return _.where($scope.filteredWorkPeriods, function(wp) {
          return dayTwix.contains(wp.start_time);
        });
      });
      //console.log(_.cloneDeep($scope.workPeriodsByDay));

      $scope.unassignedWorkPeriodsByDay = _.map($scope.dateRangesInWeek, function(dayTwix) {
        return _.where($scope.filteredWorkPeriods, function(wp) {
          return !wp.$isAssigned() && dayTwix.contains(wp.start_time);
        });
      });

      _.forEach($scope.allUsers, function(u) {
        u._workPeriodsByDay = _.map($scope.workPeriodsByDay, function(dayOfWps) {
          return _.where(dayOfWps, function(wp) {
            return wp.$isAssigned() && wp.user.id === u.id;
          });
        });
      });

      console.log('updateWorkPeriodObjects end');
    };

    updateWorkPeriodObjects();

    var updateHasUnassignedByDept = function() {
      $scope.hasUnassignedWorkPeriodsByDept = {};
      _.forEach($scope.departments, function(dept) {
        $scope.hasUnassignedWorkPeriodsByDept[dept.id] = _.any($scope.unassignedWorkPeriodsByDay, function(workPeriods) {
          return _.any(workPeriods, function (wp) {
            return _.contains(dept._position_ids, wp.position_id);
          });
        });
      });

      $scope.hasUnassignedWorkPeriods = _.any($scope.hasUnassignedWorkPeriodsByDept, function(val) { return !!val; });
    };

    var updateUserHasWorkPeriodsByDept = function() {
      $scope.userHasWorkPeriodsByDept = {};
      $scope.userHasWorkPeriods = {};
      _.forEach($scope.allUsers, function(u) {
        $scope.userHasWorkPeriodsByDept[u.id] = {};
        _.forEach($scope.departments, function(dept) {
          $scope.userHasWorkPeriodsByDept[u.id][dept.id] = _.any(u._workPeriodsByDay, function(workPeriods) {
            return _.any(workPeriods, function (wp) {
              return _.contains(dept._position_ids, wp.position_id);
            });
          });
        });
        $scope.userHasWorkPeriods[u.id] = _.any($scope.userHasWorkPeriodsByDept[u.id], function(a) { return !!a;});

      });
    };

    var calculateDaysOffStructure = function() {
      $scope.allUsers = _.map($scope.allUsers, function(u) {
        u._daysOffByDay = [[],[],[],[],[],[],[]];
        u._daysOffCoverageByDay = [[],[],[],[],[],[],[]];
        u._daysOffIssueByDay = [false, false, false, false, false, false, false];
        return u;
      });

      var idx;
      _.each($scope.approvedDaysOff, function(dayOff) {
        _.each($scope.dateRangesInWeek, function(dt, idy) {
          if (dayOff.range_twix.overlaps(dt) && Math.abs(dayOff.range_twix.intersection(dt).length('minutes')) > 0) {
//          if (dayOff.start.isSame(dt.start ,'second') || (dayOff.range_twix.contains(dt.start) && !dayOff.range_twix.end.isSame(dt.start))) {
            idx = _.findIndex($scope.allUsers, {id: dayOff.user_id});
            if (idx > -1) {
              $scope.allUsers[idx]._daysOffByDay[idy].push(dayOff);
            }
          }
        });
      });

      _.each($scope.allUsers, function(u) {
        _.each($scope.dateRangesInWeek, function(dt, idy) {
          _.each(u._daysOffByDay[idy], function(item) {
            // take intersection of dt with item.
            // create array with start, stop percentage with coverage of area by intersection
            var inter = item.range_twix.intersection(dt);
            var startMinutesPerc = (inter.start.hour() * 60 + inter.start.minute()) / (24 * 60) * 100;
            var endMinutesPerc = ((inter.end.hour() * 60 + inter.end.minute()) / (24 * 60) + (inter.start.day() === inter.end.day() ? 0 : 1)) * 100;
            if (endMinutesPerc !== 0) {
              u._daysOffCoverageByDay[idy].push([startMinutesPerc + '%', (endMinutesPerc - startMinutesPerc) + '%']);
            }

            _.each(u._workPeriodsByDay[idy], function(wp) {
              if (wp.range_twix.overlaps(item.range_twix) && Math.abs(wp.range_twix.intersection(inter).length('minutes')) > 0) {
                u._daysOffIssueByDay[idy] |= true;
              }
            });
          });
        });
      });
    };

    $scope.openSettings = function() {
      var modalInstance = $uibModal.open({
        keyboard: false,
        size: 'md',
        templateUrl: 'views/printSettings.html',
        controller: ['$scope', '$uibModalInstance', 'params', function($scope, $uibModalInstance, params) {
          $scope.me = params.me;
          $scope.settings = _.cloneDeep(params.settings);

          if ($scope.settings.groupByDepartment) {
            $scope.settings.groupByDepartment = 'true';
          } else {
            $scope.settings.groupByDepartment = 'false';
          }


          $scope.state = {
            derivedPermissions: params.derivedPermissions
          };

          $scope.close = function() {
            if ($scope.settings.groupByDepartment === 'false') {

              $scope.settings.selectedDepartment = -1;

              $scope.settings.groupByDepartment = false;
            } else {
              $scope.settings.groupByDepartment = true;
            }

            $uibModalInstance.close($scope.settings);
          };

          $scope.showUnpublishedSetting = params.showUnpublishedSetting;
          $scope.showApprovedDaysOffSetting = params.showApprovedDaysOffSetting;
          $scope.showPageOrientationSetting = params.showPageOrientationSetting || false;
          $scope.showGroupByDepartmentSetting = params.showGroupByDepartmentSetting;

          var showNoDepartmentArea = _.any($scope.allPositions, {department_id: null});

          $scope.selectDepartments = _.cloneDeep(params.departments);
          if (_.findIndex($scope.selectDepartments, {id: -1}) === -1) {
            $scope.selectDepartments.push({
              id: -1,
              name: 'All Departments'
            });
          }

          if (!showNoDepartmentArea) {
            _.remove($scope.selectDepartments, {id: null});
          }

          if (_.any($scope.selectDepartments, function(dept) {
            return !_.isNull(dept.id) && dept.id > -1;
          })) {
            $scope.showDepartmentSelect = true;
          }

          $scope.$watch('settings.autoRefresh', function() {
            if ($scope.settings.autoRefresh === false) {
              $scope.settings.autoRefreshFaster = false;
              $scope.settings.autoRefreshFasterTimer = 0;
            }

          });
        }],
        resolve: {
          params: function() {
            return {
              me: $scope.me,
              settings: $scope.settings,
              departments: $scope.departments,
              showUnpublishedSetting: true,
              showApprovedDaysOffSetting: false,
              showGroupByDepartmentSetting: true,
              derivedPermissions: $scope.state.derivedPermissions
            };
          }
        }
      });

      modalInstance.result.then(function(result) {
        lastRefreshSettings = $scope.settings.autoRefresh ? 1 : 0 + $scope.settings.autoRefreshFaster ? 1 : 0;
        $scope.settings = result;
        storePrintSettings();
        updateWorkPeriodObjects();
        updateView();
      });
    };

    var storePrintSettings = function() {
      var attributes = ['autoRefresh', 'showApprovedDaysOff', 'groupByDepartment',
        'onlyShowUsersWithWorkPeriods', 'selectedDepartment'];

      var storedSettings = Session.getPrintSettings();
      if (_.isNull(storedSettings) || _.isUndefined(storedSettings)) {
        storedSettings = {};
      }

      if (!_.has(storedSettings, 'weekView')) {
        storedSettings['weekView'] = {};
      }

      _.each(attributes, function(attr) {
        storedSettings['weekView'][attr] = $scope.settings[attr];
      });

      Session.setPrintSettings(storedSettings);
    };


  });
